import { ProjectData } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { getCarbonIntensityState } from 'src/modules/carbon-intensity/selectors/getCarbonIntensityState';
import { setInitialCarbonIntensity } from 'src/modules/hvac/utils/setInitialCarbonIntensity';
import { assertNotEmpty } from 'src/utils/assert';
import { call, select } from 'typed-redux-saga';

export function* resolveInitialProjectData(project: ProjectData): SagaIterator<ProjectData> {
  const carbonIntensityState = yield* select(getCarbonIntensityState);
  const carbonIntensityValue = assertNotEmpty(
    carbonIntensityState.get(project.building.address.country),
    `No carbon intensity data for "${project.building.address.country}"`,
    { carbonIntensityState, project },
  );
  const carbonIntensityResolver = yield* call(
    setInitialCarbonIntensity,
    { carbonIntensityOfElectricity: carbonIntensityValue.value },
  );

  return yield* call(carbonIntensityResolver, project);
}
